module.exports = "/_next/static/images/FrameMobile-f68a36802ee89a9d5fef73e0e66ff883.png";